<template>
  <div>
    <Headersys />
    <div class="content">
      <button @click="getGJJ">公积金</button>
      <img v-for="(item, idx) in imgUrlList" :key="idx" :src="item" alt="">
      <!--开启摄像头-->
      <!-- <img @click="callCamera" :src="headImgSrc" alt="摄像头"> -->
      <!--canvas截取流-->
      <!-- <canvas ref="canvas" width="640" height="480"></canvas> -->
      <!--图片展示-->
      <!-- <video ref="video" width="640" height="480" autoplay></video> -->
      <!--确认-->
      <!-- <el-button size="mini" type="primary" @click="photograph">确认</el-button> -->
      <!-- <el-button size="mini" type="primary" @click="getAccToken">Access_token</el-button> -->
      <!-- <img class="qrcoe-img" :src="codeImage" alt=""> -->
      <div>
        <div class="yyzz-content">
          <img class="yyzz-img" src="@/assets/images/yyzz-bg.jpg" alt="">
          <div class="uniscid-title" @click="addddd">统一社会信用代码</div>
          <div class="uniscid-item">91370700MA3NRP308Q</div>
          <!-- lang="zh" -->
          <div class="yyzz-A name-box left-name" lang="zh">名称</div>
          <div class="yyzz-A item-box left-item">潍坊中盛汇智软件有限公司</div>
          <div class="yyzz-A name-box right-name">注册资本</div>
          <div class="yyzz-A item-box right-item">壹佰万元整</div>
          <div class="yyzz-B name-box left-name">类型</div>
          <div class="yyzz-B item-box left-item">有限责任公司(自然人投资或控股)</div>
          <div class="yyzz-B name-box right-name">营业期限</div>
          <div class="yyzz-B item-box right-item">2018年12月11日至 年 月 日</div>
          <div class="yyzz-C name-box left-name">法定代表人</div>
          <div class="yyzz-C item-box left-item">张萍</div>
          <div class="yyzz-C name-box right-name">住所</div>
          <div class="yyzz-C item-box right-item">山东省潍坊市寒亭区北海路2998号潍坊总部基地一期工程东区5号楼202-2号</div>
          <div class="yyzz-D name-box left-name">经营范围</div>
          <div class="yyzz-D item-box left-item opscope">
            计算机软件研发、销售、咨询服务；信息系统集成服务、数据处理、数据存储服务；网络工程及监控工程技术服务；销售：计算机、软件及辅助设备、网络产品(不含卫星电视广播地面接收设施)、办公用品、五金产品、通讯设备、监控设备；信息技术咨询与服务；企业管理咨询服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动）。
          </div>
          <div class="year time-box">2021</div>
          <div class="month time-box">11</div>
          <div class="day time-box">24</div>
        </div>
        <!-- <div class="goback-btn">
          打印
        </div> -->
      </div>
      <Back />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headImgSrc: require('@/assets/logo.png'),
      imgUrlList: ""
    }
  },
  mounted() {
    // var date = new Date('2024-01-26').getTime()
    // console.log(date);
    // var time = this.$fun.getTime(date)
    // console.log(time);
  },
  methods: {
    getGJJ() {
      this.$rqt.gjjapi_selectNameGetgJJ({
        type: "1",
        name: "曹晓旭",
        idCard: "370705199008300062"
      }).then(res => {
        if (res.code == 200) {
          var data = JSON.parse(res.data.msg)
          this.pdfToimg(data.body.data)
        }
      })
    },
    pdfToimg(base64) {
      this.$rqt.gjjapi_decryptBase64({ base64 }).then(res => {
        this.imgUrlList = res.data
      })
    },
    addddd() {
      this.$fun.getMAC();
    },
    getAccToken() {
      var apiKey = 'XM4dcAlEWxuw3sEKGvAtNVAy'
      var secret = 'bm3A3rlN7EygOb4XYdYzw6NlBRe7iRDl'
      this.$rqt.Access_token(apiKey, secret).then(res => {
        console.log(res);
      })
    },
    // 调用摄像头
    callCamera() {
      // H5调用电脑摄像头API
      navigator.mediaDevices.getUserMedia({
        video: true
      }).then(success => {
        console.log(success)
        // 摄像头开启成功
        const video = this.$refs.video;
        video.srcObject = success
        // 获取当前视频的镜像状态
        let transformValue = video.style.transform;
        // 如果已经是镜像，则取消镜像；否则应用镜像
        if (transformValue.includes('scaleX')) {
          video.style.transform = '';
        } else {
          video.style.transform = 'scaleX(-1)';
        }
        // 实时拍照效果
        video.play()
      }).catch(error => {
        console.error('摄像头开启失败，请检查摄像头是否可用！')
      })
    },
    // 拍照
    photograph() {
      let ctx = this.$refs['canvas'].getContext('2d')
      // 把当前视频帧内容渲染到canvas上
      ctx.drawImage(this.$refs['video'], 0, 0, 640, 480)
      // 转base64格式、图片格式转换、图片质量压缩
      let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg', 0.7)

      // 由字节转换为KB 判断大小
      let str = imgBase64.replace('data:image/jpeg;base64,', '')
      let strLength = str.length
      let fileLength = parseInt(strLength - (strLength / 8) * 2)
      // 图片尺寸  用于判断
      let size = (fileLength / 1024).toFixed(2)
      console.log(size)

      // 上传拍照信息  调用接口上传图片 .........

      // 保存到本地
      this.dialogCamera = false
      let ADOM = document.createElement('a')
      ADOM.href = this.headImgSrc
      ADOM.download = new Date().getTime() + '.jpeg'
      ADOM.click()
    },
    // 关闭摄像头
    closeCamera() {
      if (!this.$refs['video'].srcObject) {
        this.dialogCamera = false
        return
      }
      let stream = this.$refs['video'].srcObject
      let tracks = stream.getTracks()
      tracks.forEach(track => {
        track.stop()
      })
      this.$refs['video'].srcObject = null
    },
  }
}
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  background-color: #fff;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.yyzz-content {
  width: 38%;
  margin: auto;
  position: relative;
}

.yyzz-img {
  width: 100%;
  display: block;
}

// 统一社会信用代码
.uniscid-title {
  position: absolute;
  top: 33rem;
  left: 13rem;
  z-index: 7;
  font-size: 2.5rem;
}

// 统一社会信用代码内容
.uniscid-item {
  position: absolute;
  top: 37rem;
  left: 13rem;
  z-index: 7;
  font-size: 2rem;
  font-family: '汉仪书宋二简';
}

// 事项名称
.name-box {
  width: 16rem;
  font-size: 2.5rem;
  position: absolute;
  z-index: 7;
  text-align-last: justify;
  -moz-text-align-last: justify;
  /* 兼容firefox */
  // background-color: green;
}

// 事项内容
.item-box {
  width: 36rem;
  position: absolute;
  z-index: 7;
  font-size: 2rem;
  font-family: '汉仪书宋二简';
  // background-color: red;
}

.opscope {
  font-size: 1.5rem;
}

.left-name {
  left: 13rem;
}

.left-item {
  left: 31rem;
}

.right-name {
  left: 73rem;
}

.right-item {
  left: 91rem;
}

.yyzz-A {
  top: 48rem;
}

.yyzz-B {
  top: 54rem;
}

.yyzz-C {
  top: 60rem;
}

.yyzz-D {
  top: 66rem;
}

.time-box {
  position: absolute;
  z-index: 7;
  font-size: 3rem;
  font-family: '汉仪书宋二简';
  bottom: 12rem;
}

.year {
  right: 32rem;
}

.month {
  right: 24rem;
}

.day {
  right: 18rem;
}

.goback-btn {
  width: fit-content;
  font-size: 8rem;
  background-color: #0099FF;
  border-radius: 2rem;
  margin: 10rem auto 0;
  font-weight: bold;
  color: #ffffff;
  padding: 3rem 5rem;
}
</style>